'use client';

import React from 'react';
import Image from 'next/image';

import { PortableText } from '@portabletext/react';
import { richTextComponent } from '@/sanity/sanityPortableText';

import { CTAButton } from '@/shadcn/ui/button';

import { PageChallengeOldDesignSchema } from '@/sanity/pages/PageChallengeOldDesignTemplate';
import ChipSerif from '@/components/global/ui/ChipSerif';
import arrow from '@/public/global/dotted-arrow.svg';

export default function About({
  data,
}: {
  data: PageChallengeOldDesignSchema;
}) {
  return (
    <section className="relative z-[1] pt-[7rem] lg:py-[12rem]">
      <div className="container flex flex-col items-center">
        <ChipSerif text={data?.aboutChip} className="mb-[0.5rem]" />

        {data?.aboutTitle && (
          <div className="richtext w-[min(72rem,100%)] prose-h2:text-[5rem] lg:prose-h2:text-[6rem] prose-h2:bg-gradient-to-b prose-h2:from-black prose-h2:to-[#505050] prose-h2:bg-clip-text prose-h2:text-transparent prose-p:text-transparent prose-p:bg-[#1C1F22]/90 prose-p:bg-clip-text prose-p:[text-shadow:0_3px_3px_rgba(255,255,255,0.25)] mb-[2.5rem] lg:mb-[5rem] flex flex-col gap-[2rem]">
            <PortableText
              value={data.aboutTitle}
              components={richTextComponent}
            />
          </div>
        )}

        <div className="w-[min(166.875rem,100%)] rounded-[2rem] lg:rounded-[5rem] bg-[#E6EDE9] py-[7rem] lg:pt-[7rem] lg:pb-[7rem] px-[2rem] sm:px-[5rem] relative overflow-clip">
          <div className="mx-auto w-[min(132.25rem,100%)] flex flex-col lg:flex-row items-center lg:justify-between gap-[3.5rem] relative z-10">
            <div className="flex flex-col items-center lg:items-start w-[min(65.75rem,100%)]">
              {data?.aboutSubtitle && (
                <div className="richtext richtext-start prose-img:!my-0 prose-img:!w-[6.5rem] prose-h2:text-center lg:prose-h2:text-start lg:prose-h2:text-[5rem]  prose-p:bg-[#103037] mb-[2rem] lg:mb-[3rem] flex flex-col gap-[2rem]">
                  <PortableText
                    value={data.aboutSubtitle}
                    components={richTextComponent}
                  />
                </div>
              )}

              {data?.aboutImage && (
                <Image
                  className="w-[min(56.25rem,100%)] rounded-[2.5rem] lg:hidden mb-[2rem]"
                  src={data.aboutImage}
                  alt=""
                />
              )}

              <div className="flex flex-col gap-[4rem]">
                {data?.aboutArrowList &&
                  data.aboutArrowList.length &&
                  data.aboutArrowList.map((item, index) => (
                    <div
                      key={'arrow' + index}
                      className="flex items-start gap-[1.5rem]"
                    >
                      <Image
                        src={arrow}
                        alt=""
                        className="!w-[3.25rem] shrink-0"
                      />
                      <div className="richtext richtext-start prose-p:text-[#103037]/70">
                        <PortableText
                          value={item.text}
                          components={richTextComponent}
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <CTAButton
                className="[&_.button]:mx-auto lg:[&_.button]:mx-0 mt-[4rem]"
                data={data?.aboutCTA}
              />
            </div>

            {data?.aboutImage && (
              <Image
                className="w-[min(56.25rem,100%)] rounded-[2.5rem] hidden lg:block"
                src={data.aboutImage}
                alt=""
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
